/**
 * Homepage Component
 * Displays all eBooks in a grid layout with download functionality
 */

import React, { useState, useEffect } from 'react';
import EbookCard from '../components/EbookCard';
import DownloadModal from '../components/DownloadModal';
import { fetchEbooks } from '../api';

const HomePage = () => {
  const [ebooks, setEbooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEbook, setSelectedEbook] = useState(null);
  const [refreshStats, setRefreshStats] = useState(0);

  // Fetch eBooks on component mount
  useEffect(() => {
    loadEbooks();
  }, []);

  // Load eBooks from API
  const loadEbooks = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await fetchEbooks();

      if (response.success) {
        setEbooks(response.data);
      } else {
        setError('Failed to load eBooks');
      }
    } catch (err) {
      console.error('Error fetching eBooks:', err);
      setError('Failed to connect to server. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  // Handle download button click
  const handleDownloadClick = (ebook) => {
    setSelectedEbook(ebook);
    setIsModalOpen(true);
  };

  // Handle successful download
  const handleDownloadSuccess = (downloadLink, ebookId) => {
    // Trigger a stats refresh for all eBook cards
    setRefreshStats((prev) => prev + 1);

    // Reload eBooks to update stats
    loadEbooks();
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedEbook(null);
  };

  return (
    <div className="container" id="ebook">
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem', marginTop: '1rem' }}>
        <a
          href="https://siragupathippagam.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="back-button-brown"
          title="Back to main website"
        >
          ← Back
        </a>
      </div>
      {/* <h1 className="page-title">📚 Tamil eBooks Library</h1> */}

      {/* Loading State */}
      {loading && (
        <div className="loading">
          <div className="spinner"></div>
        </div>
      )}

      {/* Error State */}
      {error && !loading && (
        <div className="text-center mt-3">
          <p style={{ color: '#dc3545', fontSize: '1.1rem' }}>
            ❌ {error}
          </p>
          <button className="btn" onClick={loadEbooks} style={{ marginTop: '1rem', maxWidth: '200px' }}>
            🔄 Retry
          </button>
        </div>
      )}

      {/* Empty State */}
      {!loading && !error && ebooks.length === 0 && (
        <div className="text-center mt-3">
          <p style={{ fontSize: '1.1rem', color: '#999' }}>
            📭 No eBooks available yet. Please check back later!
          </p>
        </div>
      )}

      {/* eBooks Grid */}
      {!loading && !error && ebooks.length > 0 && (
        <div className="ebook-grid">
          {ebooks.map((ebook) => (
            <EbookCard
              key={ebook.id}
              ebook={ebook}
              onDownloadClick={handleDownloadClick}
              refreshStats={refreshStats}
            />
          ))}
        </div>
      )}

      {/* Download Modal */}
      <DownloadModal
        isOpen={isModalOpen}
        onClose={closeModal}
        ebook={selectedEbook}
        onSuccess={handleDownloadSuccess}
      />
    </div>
  );
};

export default HomePage;
